import {Typography} from "@material-ui/core";
import React from "react";

export const AnswerPreview = ({text, setNavigationStatus, navigationStatus, faqSelection, faq}) => {
  const isMobile = window.innerWidth < 500;
  const chartLimit = isMobile ? 200 : 300
  let output = text.length < chartLimit ? text : text.substring(0, chartLimit).concat(' ...')
  output = output.replace(/&nbsp;/g, ' ')
  return (<Typography variant="body2" style={{marginTop: 10, marginBottom: 10}}
                      onClick={() => {
                        faqSelection(faq);
                        setNavigationStatus(navigationStatus);
                      }}>{output}</Typography>)
}